// Shared link data for the Navbar and Footer.
// Edit routes here once and both components update.
// NOTE: the /solutions/<slug> and /blog routes below are assumptions,
// change them to match your React Router paths.

export const useCases = [
  { label: "High-Volume Hiring", desc: "Interview every applicant, at any volume.", path: "/solutions/high-volume-hiring", icon: "users" },
  { label: "Developer Hiring", desc: "Verify real coding skills early.", path: "/solutions/developer-hiring", icon: "code" },
  { label: "Technical Screening", desc: "A structured, verified first round.", path: "/solutions/technical-screening", icon: "filter" },
  { label: "Remote Hiring", desc: "Trusted interviews from anywhere.", path: "/solutions/remote-hiring", icon: "globe" },
  { label: "Campus Hiring", desc: "Find your best graduates.", path: "/solutions/campus-hiring", icon: "cap" },
];

export const industries = [
  { label: "BFSI", desc: "Banking, financial services and insurance.", path: "/solutions/bfsi", icon: "bank" },
  { label: "Healthcare", desc: "Clinical support, IT and operations.", path: "/solutions/healthcare", icon: "heart" },
  { label: "IT Services and SaaS", desc: "Developers and client project teams.", path: "/solutions/it-services-saas", icon: "chip" },
  { label: "eCommerce", desc: "Tech, support and seasonal hiring.", path: "/solutions/ecommerce", icon: "cart" },
  { label: "Manufacturing", desc: "Engineers, plant and supply chain roles.", path: "/solutions/manufacturing", icon: "factory" },
];

export const resources = [
  { label: "Blog", desc: "Insights on fair, secure hiring.", path: "/blog", icon: "doc" },
  { label: "FAQ", desc: "Answers to common questions.", path: "/faq", icon: "chat" },
];